import React from 'react'; 
import { TextField, Grid, Avatar, MenuItem, Select, Fab,} from '@material-ui/core';
import Utils from '../providers/Utils';
import LocalStorage from '../providers/LocalStorage';
import PropTypes from 'prop-types';
import Menu from '../commons/Menu'
import Calendar from 'react-calendar';
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en'

export default class EtapeList extends React.Component{
    constructor(props){
        super(props);
    }


    state = {
        elementeAfisate: this.props.elemente || [],
        searchString: '',
        titleDisplay:true,
        titleId:0,
        titleText:'',
        timerDisplay:false,
         timerId:0,
          timerText:new Date(),
        timerKind:'',
       
        year:2019,
        month:0,
        day:1,
        days:31,
        noteText:''
    } 

    componentDidMount(){

    }

   onChange=(ev,e)=>{
    // console.log('event change time---2-2-2--2-22--2-2-22-2-s :', ev);

    this.setState({timerText:ev},()=>{
        this.changeTime(e)
    })
   }


    changeTime=(e)=>{


        let time = this.state.timerText

        // console.log('time-----------------xxxxxx--xx-x-x--x :', time);

        let u = new Utils();


            this.setState({timerDisplay:false},()=>{
                this.props.changeTimer(e, u.transformDataForSql(time), this.state.timerKind)

            })


         
    }

    // dateClick=(e)=>{

    //     // console.log('e -clicked:', e);
    //     if(this.state.timerKind === 'dela'){
    //         let date = new Date(e.durata_de_la)

    //         this.setState({date:date})
    //     }else{
    //         let date = new Date(e.durata_pana_la)

    //         this.setState({date:date})
    //     }
    // }


    // datePicker = (e) =>{
      
       
    //     let inputElement = document.createElement('input')

    //     inputElement.id = 'testInput'
    //     inputElement.type = 'date'

        

         

    //         console.log('time :', inputElement);
    //         if(inputElement.type === 'text'){

    //             let container = []
    //             let years = this.populateYear()
    //             let months = this.populateMonth()
    //             let days = this.populateDays()
                
    //              container.push(days)
    //             container.push(months)
    //             container.push(years)
                

             

            

    //             return <div style={{display:this.state.timerDisplay ? 'none' : (e.id===this.state.timerId ? 'block' : 'none')}}>{container} <i className='material-icons' onClick={()=>{this.setState({timerDisplay:true, timerId:e.id},()=>{this.props.changeTimer(e,this.state.year+'-'+(this.state.month+1) +'-'+this.state.day, this.state.timerKind)})}}>done</i></div>
                
           
    //             console.log('safari  :' );
    //         }else{

    //             console.log('any browser :');
    //             return     <input  className='pm-etapa-timer-input'  onBlur={()=>{this.setState({timerDisplay:true, timerId:e.id},()=>{this.props.changeTimer(e,this.state.timerText, this.state.timerKind)})}} style={{display:this.state.timerDisplay ? 'none' : (e.id===this.state.timerId ? 'block' : 'none')}} type='date' value={this.state.timerText} onChange={(ev)=>{this.setState({timerText:ev.target.value})}}/>
                                  
           
                
    //         }
        
    // }



    componentWillReceiveProps(nextProps){
        this.setState({
            elementeAfisate:nextProps.elemente || [],
        })
    }

    getLitereAvatar = (tx)=>{

        // console.log('tx :', tx);

        if(tx !== null){

            return tx.substring(0,2)
        }
    }

    filterFunc = (ev) => {

        this.setState({searchString:ev.target.value})
        let e = [...this.props.elemente]

        e = e.filter(x=>{
            
            if( (x[this.props.onlyColumns.title]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
                return true
            
            if( (x[this.props.onlyColumns.description]||'').toLowerCase().trim().includes( ev.target.value.toLowerCase() )  )
                return true
            
            return false

        })

        this.setState({elementeAfisate: e})
    }

    render(){
        return (
            <div style={{overflow:'scroll'}}>
                       

                <TextField className='inputFocus' label={this.props.dict.comune.search} onChange={this.filterFunc} value={this.state.searchString} />
                <ul className='pm-list-container'>
               
                             
                    {
                        this.state.elementeAfisate.map( (e,idx) =>{
                            return (
                                <li className='pm-list-item' key={idx} >
                                   <div className='pm-list-borderleft'></div>
                                <Grid container className='pm-list-container-item'>
                                

                                    <Grid item xs={4} sm={4} md={4} lg={4} xl={4}  className='pm-list-container-item-content'>
                                        <span onClick={()=>{this.setState({titleDisplay:false, titleId:e.id, titleText:e.denumire})}} style={{display:this.state.titleDisplay ? 'block' : (e.id===this.state.titleId ? 'none' : 'block')}} className='pm-list-item-span'>{e[this.props.onlyColumns.title]}</span>
                                        <span onClick={()=>{this.setState({titleDisplay:false, titleId:e.id,noteText:e.note})}} style={{display:this.state.titleDisplay ? 'block' : (e.id===this.state.titleId ? 'none' : 'block')}} className='pm-list-item-span'>{e[this.props.onlyColumns.note]}</span>
                                       
                                        <input className='pm-etapa-title-input'  onBlur={()=>{this.setState({titleDisplay:true, titleId:e.id},()=>{this.props.changeTitle(e,this.state.titleText)})}} style={{display:this.state.titleDisplay ? 'none' : (e.id===this.state.titleId ? 'block' : 'none')}} type='text' value={this.state.titleText} onChange={(ev)=>{this.setState({titleText:ev.target.value})}}/><br/>
                                        <input className='pm-etapa-title-input'  onBlur={()=>{this.setState({titleDisplay:true, titleId:e.id},()=>{this.props.changeNote(e,this.state.noteText)})}} style={{display:this.state.titleDisplay ? 'none' : (e.id===this.state.titleId ? 'block' : 'none')}} type='text' value={this.state.noteText} onChange={(ev)=>{this.setState({noteText:ev.target.value})}}/>
                                    
                                    </Grid>
                                    <Grid item xs={1} sm={1} md={1} lg={1} xl={1} className='pm-list-container-item-content'>
                                    <div style={{width:'100%', height:'100%', position:'relative'}}>
                                        <Avatar onClick={()=>{this.props.avatarClick(e)}} style={{margin:'5px auto'}} className='pm-avatar'> { this.getLitereAvatar(e[this.props.onlyColumns.idUser] + ' ') } </Avatar>

                                           
                                                <Menu 
                                                    openMenu={this.props.openMenuAvatar}
                                                    e={e}
                                                    elSelectat={this.props.elSelectat}
                                                    closeMenu={this.props.closeMenuAvatar}
                                                    el={this.props.users}
                                                    text={'nume'} />
                                                </div>
                                    </Grid>

                                      {e[this.props.onlyColumns.dataStart] && 
                                      <Grid item xs={4} sm={4} md={4} lg={4} xl={4} className='pm-list-container-item-content'>

                                     <div className='pm-list-timer-container'>
                                    <div className='pm-list-timer-container-fill' style={{width: new Utils().getDatePercent(e[this.props.onlyColumns.dataStart],e[this.props.onlyColumns.dataFinish] )}}></div>
                                    <span  className='pm-list-timer-text'>{new LocalStorage().GetUserPreferences().language === 'ro' ? ( <span><span onClick={()=>{this.setState({timerDisplay:true, timerId:e.id, timerText:new Date(e.durata_de_la), timerKind:'dela'})}}>{new Utils().dataPrescurtataRomana(e[this.props.onlyColumns.dataStart]) } - </span>  <span onClick={()=>{this.setState({timerDisplay:true, timerId:e.id, timerText:new Date(e.durata_pana_la), timerKind:'panala'})}}>{ new Utils().dataPrescurtataRomana(e[this.props.onlyColumns.dataFinish])}</span> </span>) :( <span><span onClick={()=>{this.setState({timerDisplay:true, timerId:e.id, timerText:new Date(e.durata_de_la), timerKind:'dela'})}}>{new Utils().dataPrescurtataEng(e[this.props.onlyColumns.dataStart]) } - </span>  <span onClick={()=>{this.setState({timerDisplay:true, timerId:e.id, timerText:new Date(e.durata_pana_la), timerKind:'panala'})}}>{ new Utils().dataPrescurtataEng(e[this.props.onlyColumns.dataFinish])}</span> </span>) }</span> 
                                       
                                        {/* <input id={`pm-etapa-timer-input${e.id}`} className='pm-etapa-timer-input'  onBlur={()=>{this.setState({timerDisplay:true, timerId:e.id},()=>{this.props.changeTimer(e,this.state.timerText, this.state.timerKind)})}} style={{display:this.state.timerDisplay ? 'none' : (e.id===this.state.timerId ? 'block' : 'none')}} type='date' value={this.state.timerText} onChange={(ev)=>{this.setState({timerText:ev.target.value})}}/> */}
                                   {/* { this.datePicker(e)  } */}
                                       <div style={{display:this.state.timerDisplay ? (e.id===this.state.timerId ? 'block' : 'none') : 'none' , position:'relative'}}>
                                       <Fab  onClick={()=>{this.setState({timerDisplay:false})}} className="pm-calendar-cancel">
                                      <i className='material-icons pm-round-button-text'>clear</i>
                                        </Fab>
                                        <Calendar
                                            className='pm-calendar-etape'
                                            locale={this.props.dict.date}
                                            onChange={(ev)=>{this.onChange(ev,e)}}
                                            value={this.state.timerText}
                                            />
                                            </div>
                                    </div>
                      
                                    </Grid>
                                    }
                                    <Grid 
                                            style={{backgroundColor:new Utils().statusulColor(e[this.props.onlyColumns.statusul])}} item xs={3} sm={3} md={3} lg={3} xl={3} className='pm-list-container-item-content'>
                                 

                                <div style={{width:'100%', height:'100%', position:'relative'}}>

                                        <span onClick={()=>{this.props.elementSelectat('Status',e )}} className='pm-list-status-text'>{new Utils().statusText(e[this.props.onlyColumns.statusul]) || this.props.dict.proiecte.status.inlucru }</span>
                                       <Menu 
                                            openMenu={this.props.openMenu}
                                            e={e}
                                            elSelectat={this.props.elSelectat}
                                            closeMenu={this.props.closeMenu}
                                            el={this.props.status}
                                            text={'text'} />
                                </div>
                                        
                                    
                                    
                      
                                    </Grid>
                                </Grid>
                                   
                                </li>
                            )
                        })
                    }
                </ul>

            </div>
        );
    }


}// end class


EtapeList.propTypes={
    elemente:PropTypes.array,
    onlyColumns:PropTypes.object,
    dict:PropTypes.object,
    elementSelectat:PropTypes.func,
    closeMenu:PropTypes.func,
    elSelectat:PropTypes.object,
    status:PropTypes.array,
    openMenu:PropTypes.bool,
    changeTimer:PropTypes.func
}